import { render, staticRenderFns } from "./AppointmentResult.vue?vue&type=template&id=475c5559&"
import script from "./AppointmentResult.vue?vue&type=script&lang=js&"
export * from "./AppointmentResult.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports